import { createContext, useState } from "react";

export const ShopContext = createContext();

export const ShopProvider = ({ children }) => {
  const [filteredData, setFilteredData] = useState({
    retailerShop: { shopdata: [], itemmdata: [], additionalData: {} },
    wholesellerShop: { shopdata: [], itemmdata: [], additionalData: {} },
    homemadeShop: { shopdata: [], itemmdata: [], additionalData: {} },
    manufacturerShop: { shopdata: [], itemmdata: [], additionalData: {} },
    rawmaterialShop: { shopdata: [], itemmdata: [], additionalData: {} },
    gemShop: { shopdata: [], itemmdata: [], additionalData: {} },
    usedShop: { shopdata: [], itemmdata: [], additionalData: {} },
    jobsCompany: { shopdata: [], itemmdata: [], additionalData: {} },
    foodShop: { shopdata: [], itemmdata: [], additionalData: {} },
    services: { shopdata: [], itemmdata: [], additionalData: {} },
    transportShop: { shopdata: [], itemmdata: [], additionalData: {} },
    businessPropertyCompany: { shopdata: [], itemmdata: [], additionalData: {} },
    farmingShop: { shopdata: [], itemmdata: [], additionalData: {} },
    recycledShop: { shopdata: [], itemmdata: [], additionalData: {} },
    usedVehicleShop: { shopdata: [], itemmdata: [], additionalData: {} },
    singleItem: { shopdata: [], itemmdata: [], additionalData: {} },
    jobCandidates: { shopdata: [], employeedata: [], additionalData: {} },
    singleProperty: { shopdata: [], itemmdata: [], additionalData: {} },

  });

  const updateFilteredData = (shopType, shopdata, itemmdata, additionalData) => {
    setFilteredData(prev => ({
      ...prev,
      [shopType]: { shopdata, itemmdata, additionalData }
    }));
  };

  const getFilteredData = (shopType) => {
    return filteredData[shopType] || { shopdata: [], itemmdata: [], additionalData: {} };
  };

  return (
    <ShopContext.Provider value={{ filteredData, updateFilteredData, getFilteredData }}>
      {children}
    </ShopContext.Provider>
  );
};
